import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Dictionary } from 'lib';
import { useDictionaryDetails } from 'hooks';
import { HelixLoader } from '../../../components';
import { AttributeListContextProvider } from '../contexts/AttributeListContext';
import { IndexListContextProvider } from '../contexts/IndexListContext';
import { DictionaryManager } from './DictionaryManager';

export const EditDictionary = (): React.JSX.Element => {
    const { dictionaryId } = useParams();
    const [dictionaryData, setDictionaryData] = useState<Dictionary>();

    const onLoadSuccess = (data: any): void => {
        setDictionaryData(data);
    };

    const onLoadError = (val: any): void => {
        console.log('val', val);
    };

    const { isLoading } = useDictionaryDetails({
        dictionaryId,
        onLoadSuccess,
        onLoadError,
    });

    if (isLoading) {
        return <HelixLoader />;
    }

    return (
        <AttributeListContextProvider>
            <IndexListContextProvider>
                {dictionaryData ? (
                    <DictionaryManager
                        dictionaryData={dictionaryData}
                        isLoading={isLoading}
                        isEdit={true}
                        isPredicted={false}
                    />
                ) : (
                    <></>
                )}
            </IndexListContextProvider>
        </AttributeListContextProvider>
    );
};
